import { render } from "./Integerations.vue?vue&type=template&id=1f383bf8&scoped=true"
import script from "./Integerations.vue?vue&type=script&lang=js"
export * from "./Integerations.vue?vue&type=script&lang=js"

import "./Integerations.vue?vue&type=style&index=0&id=1f383bf8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1f383bf8"

export default script